import { styled, Button, ButtonProps, keyframes, css } from "@mui/material";

const rotateAnimation = keyframes`
0% {
  transform: rotate(0deg);
}
50% {
  transform: rotate(360deg);
}
100% {
  transform: rotate(0deg);
}
`;

export interface IFrameButtonProps extends ButtonProps {
  backgroundColor?: string;
  hasText?: boolean;
  isSpinning?: boolean;
  isBottomPlacement?: boolean;
}

export const IFrameButton = styled(
  ({ backgroundColor, hasText, isSpinning,isBottomPlacement, ...rest }: IFrameButtonProps) => (
    <Button {...rest} />
  )
)`
  font-family: Poppins;
  font-weight: 900;
  line-height: 15px;
  border-radius: 32px;
  background-color: ${({ backgroundColor }) => `${backgroundColor}`};
  color: #0b2f5b;
  width: ${({ hasText, isBottomPlacement }) => ((hasText && isBottomPlacement) ? "110px" : "64px")};
  height: ${({ hasText, isBottomPlacement }) => (hasText && !isBottomPlacement ? "110px" : "64px")};
  ${({ isSpinning }) =>
    isSpinning &&
    css`
      animation: ${rotateAnimation} 2s linear infinite;
    `}
  box-shadow: none;
  &:hover {
    background-color: ${({ backgroundColor }) => `${backgroundColor}`};
  }
`;

export interface IFrameButtonTitleProps extends ButtonProps {
  isBottomPlacement: boolean;
}

export const IFrameButtonTitle = styled(
  ({ isBottomPlacement, ...rest }: IFrameButtonTitleProps) => <span {...rest} />
)`
  transform: ${({ isBottomPlacement }) =>
      isBottomPlacement ? "rotate(0deg)" : "rotate(90deg)"};
`;
